import { Injectable } from '@angular/core';
import { QuotationCommercialItem } from 'projects/dop-ordering/src/lib/models/quotable-items/quotation-commercial-item.model';
import { CommercialItemValidationResponse } from '../../models/commercial-item-validation-response.model';

@Injectable({
    providedIn: 'root'
})
export class FreePackagePlanningLineRule {

    constructor(private quotationCommercialItem: QuotationCommercialItem) { }

    validatePackage(packageCode: string): CommercialItemValidationResponse {
        const freePackage = this.quotationCommercialItem?.freeQuotationLinesPackage
            .filter(x => x.packageCode === packageCode).shift();

        return {
            data: freePackage,
            isValid: freePackage !== undefined,
        };
    }
}
